import { render, staticRenderFns } from "./DeliveryInstructionSubcontractDetailInput.vue?vue&type=template&id=b5681c7c&scoped=true&"
import script from "./DeliveryInstructionSubcontractDetailInput.vue?vue&type=script&lang=js&"
export * from "./DeliveryInstructionSubcontractDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInstructionSubcontractDetailInput.vue?vue&type=style&index=0&id=b5681c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5681c7c",
  null
  
)

export default component.exports